module.exports = __webpack_public_path__ + "img/0051.9f609dcb.jpg";